import { render, staticRenderFns } from "./MultipleFormComponent.vue?vue&type=template&id=4669340b&scoped=true&"
import script from "./MultipleFormComponent.vue?vue&type=script&lang=js&"
export * from "./MultipleFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./MultipleFormComponent.vue?vue&type=style&index=0&id=4669340b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4669340b",
  null
  
)

export default component.exports